import { apipost } from '../service/api';

// Shared Cloudinary upload helper. Posts a File to the backend upload endpoint
// (multipart field name `headshot`, matching the existing route) and returns the
// hosted image URL. Extracted from the blog editor so the blog and SEO editors
// share one implementation.
const CLOUD_UPLOAD_ENDPOINT = 'cloudinary/upload/image';

export async function uploadViaBackend(file) {
  const fd = new FormData();
  fd.append('headshot', file);
  const res = await apipost(CLOUD_UPLOAD_ENDPOINT, fd);
  if (!res || res.status < 200 || res.status >= 300) {
    throw new Error(res?.data?.message || 'Upload failed');
  }
  return res.data.url || res.data.secure_url;
}

export default uploadViaBackend;
